import { Box, Typography, useTheme } from '@mui/material';
import { BadgeCheck, X } from 'lucide-react';

import { useLocale } from '@shared/hooks/locale';
import { customPalette } from '@shared/theme/StyleProvider';

export const VerificationStatus = ({
  isVerified,
  label,
}: {
  isVerified: boolean;
  label?: string;
}) => {
  const { t } = useLocale();
  const theme = useTheme();
  const textKey =
    label ??
    (isVerified ? t('Verified transaction') : t('Transaction not verified'));

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}
    >
      {isVerified ? (
        <BadgeCheck size={16} color={theme.palette.success.main} />
      ) : (
        <X size={16} color={customPalette.gray400} />
      )}
      <Typography
        sx={{
          color: isVerified ? 'success.main' : 'text.disabled',
          fontWeight: 600,
          fontSize: '0.75rem',
        }}
      >
        {textKey}
      </Typography>
    </Box>
  );
};
